export default "__VITE_ASSET__Vb7Jojbd__"